import React, { useEffect } from 'react'
import styled from '@emotion/styled';
import {color, breakpoint, font, socialLinks} from '../../../constants';
import analyticsTriggers from '../../../analytics/triggers';
import pocketLogoImage from './images/pocket-logo.svg';
import illustrationImage from './images/illustration.svg';
import facebookImage from './images/facebook-ico.svg';
import twitterImage from './images/twitter-ico.svg';
import linkedinImage from './images/linkedin-ico.svg';

const PocketHitsConfirmLanding = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 75px 27px;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    padding: 24px 27px;
  }
  
`

const Header = styled.h1`
  font-family: ${font.DOYLE};
  font-weight: 500;
  font-size: 27px;
  line-height: 32px;
  margin-bottom: 20px;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    font-size: 25px;
    line-height: 30px;
  }
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingLarge} {
    margin-top: 45px;
  }
`

const PocketLogo = styled.a`
  display: block;
  background-image: url(${pocketLogoImage});
  background-repeat: no-repeat;
  width: 100px;
  height: 27px;
  background-size: contain;
  margin-bottom: 25px;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    width: 80px;
    height: 21px;
  }
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingLarge} {
    margin-bottom: 45px;
  }
`

const Illustration = styled.div`
  background-image: url(${illustrationImage});
  background-repeat: no-repeat;
  width: 179px;
  height: 176px;
  background-size: contain;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    width: 145px;
    height: 143px;
  }
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingLarge} {
    width: 254px;
    height: 253px;
  }
`

const Body = styled.p`
  font-family: ${font.GRAPHIK};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  text-align: center;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    font-size: 14px;
    line-height: 22px;
  }
`

const Spacer = styled.div`
  background-color: ${color.gray20};
  height: 1px;
  width: 300px;
  margin: 45px 0 40px;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    width: 100%;
    margin: 25px 0;
  }
`

const SocialText = styled(Body)`
  font-weight: 500;
`

const SocialLink = styled.a`
  mask-repeat: no-repeat;
  width: 35px;
  height: 35px;
  display: inline-block;
  mask-size: contain;
  margin: 0 7px;
  background-color: ${color.gray100};
  
  &:hover {
    transition: 200ms;
    background-color: ${color.coral80};
  }
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    width: 31px;
    height: 31px;
  }
`

const FacebookLink = styled(SocialLink)`
  mask-image: url(${facebookImage});
`
const TwitterLink = styled(SocialLink)`
  mask-image: url(${twitterImage});
`
const LinkedInLink = styled(SocialLink)`
  mask-image: url(${linkedinImage});
`

const SocialLinks = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 25px;
  
  ${breakpoint.oneOff.pocketHitsConfirmLandingSmall} {
    margin-top: 20px;
  }
`

const handleFacebookClick = (e) => {
  analyticsTriggers.pocketHitsFacebookShareClick();
}

const handleTwitterClick = (e) => {
  analyticsTriggers.pocketHitsTwitterShareClick();
}

const handleLinkedInClick = (e) => {
  analyticsTriggers.pocketHitsLinkedInShareClick();
}

export default () => {

  // on component mount
  useEffect(() => {
    analyticsTriggers.pocketHitsEmailConfirmSuccess();
  }, []);

  return (
      <PocketHitsConfirmLanding>
        <PocketLogo href="/" />
        <Illustration />
        <Header>You're all set!</Header>
        <Body>We've confirmed your e-mail address.</Body>
        <Spacer/>
        <SocialText>Get a steady stream of fascinating reads:</SocialText>
        <SocialLinks>
          <FacebookLink href={socialLinks.facebook} onClick={handleFacebookClick} target="_blank" rel="noopener noreferrer"/>
          <TwitterLink href={socialLinks.twitter} onClick={handleTwitterClick} target="_blank" rel="noopener noreferrer"/>
          <LinkedInLink href={socialLinks.linkedin} onClick={handleLinkedInClick} target="_blank" rel="noopener noreferrer"/>
        </SocialLinks>
      </PocketHitsConfirmLanding>
  )
}
